/*** Outside library ***/
import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import * as _ from 'lodash';

/*** Our services ***/
import { LocalStorageService } from '../services/local-storage.service';
import { UserService } from '../services/user.service';
import { TeamsettingsService } from '../services/teamsettings.service';
import { ParentAbility, parentAbilityIsAllowed, statsAreAllowedForUser } from '../models/team';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
      private router: Router,
      private route: ActivatedRoute,
      private localStorageService: LocalStorageService,
      private userService: UserService,
      private teamsettingsService: TeamsettingsService
  ) { 
    this.localStorageService.listenForUserUpdate()
    .subscribe(user => {
      this.checkAuth(this.route.snapshot, this.router.routerState.snapshot);
    });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.checkAuth(route, state);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.checkAuth(route, state);
  }

  async checkAuth(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const user = this.localStorageService.getUser();
    if (user) {
      let shouldProceed = true;
      if (route.hasOwnProperty('data') && route.data.hasOwnProperty('roles')) {
        if (user.currentUserRole) {
          shouldProceed = _.indexOf(route.data['roles'], user.currentUserRole.role) > -1;
        }
        else shouldProceed = false;
      }

      const parentAbility = route.data?.['parentAbility'] as ParentAbility | undefined;
      const requiresStatsAccess = route.data?.['requiresStatsAccess'] === true;
      if (shouldProceed && ((parentAbility && user.currentUserRole?.role === 'parent') || requiresStatsAccess)) {
        try {
          const response = await this.teamsettingsService.getTeamSettings(user.currentUserRole.teamid);
          shouldProceed = response.success &&
            (!parentAbility || user.currentUserRole?.role !== 'parent' || parentAbilityIsAllowed(response.result, parentAbility)) &&
            (!requiresStatsAccess || statsAreAllowedForUser(response.result, user.currentUserRole?.role));
        }
        catch (_) {
          shouldProceed = false;
        }
      }

      if (shouldProceed) {
        return true;
      } else {
        if (requiresStatsAccess && user.currentUserRole?.teamid) {
          await this.router.navigate(['/my-team']);
          return false;
        }
        // this.router.navigate(['login']);
        this.userService.performInitialNavigation(user);
        
        return false;
      }
    } else {
			this.router.navigate(['login']);
      return false;
    }
  }
}
